// 电视剧模拟数据（前端静态演示，无真实播放能力）
export const tvShows = [
  {
    id: "t-long-night",
    title: "长夜将明",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20period%20mystery%20tv%20series%20poster%20with%20a%20dim%20streetlamp%20and%20lone%20figure%20in%20a%201930s%20alley%2C%20muted%20sepia%20and%20deep%20blue%20palette%2C%20minimal%20cinematic%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-long-night-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%201930s%20city%20street%20at%20night%20with%20fog%20and%20dim%20streetlamps%2C%20muted%20sepia%20and%20deep%20blue%20palette%2C%20mysterious%20period%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-long-night-hero&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "年代", "剧情"],
    rating: 9.1,
    duration: "45分钟/集",
    episodes: 36,
    director: "韩明",
    actors: ["张跃", "沈安宁", "陆言"],
    tagline: "长夜再长，也会天亮。",
    synopsis: "上世纪三十年代的上海滩，一名年轻记者卷入连环谜案。他在夜色与谎言之间寻找真相，也逐渐看清了时代的轮廓。",
    tags: ["年代", "悬疑", "高口碑"],
  },
  {
    id: "t-city-life",
    title: "都市浮生记",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20modern%20urban%20drama%20tv%20poster%20with%20glass%20skyscrapers%20and%20warm%20window%20lights%2C%20soft%20amber%20and%20navy%20palette%2C%20minimal%20elegant%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-city-life-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20modern%20city%20skyline%20at%20dusk%20with%20warm%20window%20lights%2C%20amber%20and%20navy%20palette%2C%20elegant%20urban%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-city-life-hero&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["都市", "情感", "剧情"],
    rating: 8.4,
    duration: "42分钟/集",
    episodes: 40,
    director: "方晓",
    actors: ["周雨桐", "林川", "郑一楠"],
    tagline: "浮生若梦，也要认真生活。",
    synopsis: "四个在大城市打拼的年轻人，住在同一栋老楼里。他们的欢喜、失落与梦想，交织成一幅鲜活的都市浮世绘。",
    tags: ["群像", "都市", "现实"],
  },
  {
    id: "t-star-route",
    title: "星际航线",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20space%20sci-fi%20tv%20series%20poster%20with%20a%20sleek%20starship%20against%20a%20nebula%2C%20deep%20indigo%20and%20cyan%20palette%2C%20minimal%20futuristic%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-star-route-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20space%20scene%20with%20a%20starship%20approaching%20a%20glowing%20nebula%2C%20deep%20indigo%20and%20cyan%20palette%2C%20futuristic%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-star-route-hero&orientation=landscape",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险", "悬疑"],
    rating: 8.9,
    duration: "50分钟/集",
    episodes: 24,
    director: "Ryan Holt",
    actors: ["Chloe Vance", "Diego Marsh", "Amara Osei"],
    tagline: "航线的尽头，是未知。",
    synopsis: "一艘探索飞船驶向银河边缘，去寻找一组神秘的信号源。船员们逐渐意识到，这次任务的真正目的远比他们想象的更加复杂。",
    tags: ["太空", "科幻", "烧脑"],
  },
  {
    id: "t-healing-heart",
    title: "医心仁术",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20medical%20drama%20tv%20poster%20with%20soft%20clean%20hospital%20corridor%20light%2C%20calm%20teal%20and%20white%20palette%2C%20minimal%20human%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-healing-heart-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20hospital%20corridor%20with%20soft%20morning%20light%20and%20clean%20lines%2C%20calm%20teal%20and%20white%20palette%2C%20hopeful%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-healing-heart-hero&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["医疗", "剧情", "情感"],
    rating: 8.6,
    duration: "45分钟/集",
    episodes: 42,
    director: "陶然",
    actors: ["顾岚", "徐正", "白澄"],
    tagline: "医者仁心，向光而行。",
    synopsis: "一群年轻医生在急诊科的日日夜夜中成长。他们救治病人，也在被病人治愈，逐渐理解「仁术」二字真正的重量。",
    tags: ["医疗", "正能量", "群像"],
  },
  {
    id: "t-mist-files",
    title: "迷雾档案",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20british%20detective%20tv%20poster%20with%20a%20magnifying%20glass%20and%20rain%20streaked%20window%2C%20cool%20grey%20and%20amber%20palette%2C%20minimal%20noir%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-mist-files-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20noir%20study%20with%20scattered%20files%20and%20warm%20desk%20lamp%2C%20cool%20grey%20and%20amber%20palette%2C%20moody%20detective%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-mist-files-hero&orientation=landscape",
    year: 2024,
    region: "英国",
    genres: ["悬疑", "探案", "犯罪"],
    rating: 9.0,
    duration: "55分钟/集",
    episodes: 20,
    director: "Harriet Wells",
    actors: ["Oliver Pike", "Grace Dune", "Miles Hart"],
    tagline: "每一份档案，都藏着一个人。",
    synopsis: "一位档案管理员与一位探长联手，从尘封的旧卷宗中还原一桩悬案。随着调查深入，他们发现自己也成了案件的一部分。",
    tags: ["探案", "英剧", "高能"],
  },
  {
    id: "t-young-hero",
    title: "少年游侠传",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20chinese%20wuxia%20tv%20poster%20with%20a%20young%20swordsman%20silhouette%20against%20misty%20mountains%2C%20ink%20wash%20style%2C%20deep%20jade%20and%20gold%20palette%2C%20minimal%20elegant%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-young-hero-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20oriental%20mountain%20landscape%20with%20mist%20and%20bamboo%20forest%2C%20ink%20wash%20artistic%20rendering%2C%20deep%20jade%20palette%2C%20heroic%20atmosphere%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-young-hero-hero&orientation=landscape",
    year: 2022,
    region: "中国大陆",
    genres: ["古装", "武侠", "江湖"],
    rating: 8.2,
    duration: "44分钟/集",
    episodes: 45,
    director: "裴云",
    actors: ["叶开", "洛清", "秦朗"],
    tagline: "少年意气，仗剑天涯。",
    synopsis: "出身寒门的少年拜入名门，习武、结交、历险。他在江湖的风雨中成长为真正的侠者，也懂得了「侠之大者」的含义。",
    tags: ["武侠", "江湖", "热血"],
  },
  {
    id: "t-tasty-life",
    title: "美味人生",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20japanese%20healing%20food%20tv%20poster%20with%20a%20cozy%20small%20restaurant%20counter%20and%20warm%20lantern%20light%2C%20soft%20amber%20and%20cream%20palette%2C%20minimal%20cozy%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-tasty-life-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20cozy%20japanese%20street%20with%20warm%20lanterns%20and%20small%20shops%20at%20dusk%2C%20soft%20amber%20and%20cream%20palette%2C%20healing%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-tasty-life-hero&orientation=landscape",
    year: 2023,
    region: "日本",
    genres: ["生活", "治愈", "美食"],
    rating: 8.8,
    duration: "30分钟/集",
    episodes: 12,
    director: "中村静",
    actors: ["田中美咲", "小林彻", "铃木枫"],
    tagline: "一餐一饭，皆是人生。",
    synopsis: "一家藏在巷子里的小食堂，每到深夜就会迎来形形色色的客人。老板用一道道家常菜，治愈着每个疲惫的灵魂。",
    tags: ["治愈", "美食", "深夜剧"],
  },
  {
    id: "t-power-peak",
    title: "权力之巅",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20political%20drama%20tv%20poster%20with%20a%20marble%20hall%20and%20a%20lone%20figure%2C%20deep%20navy%20and%20gold%20palette%2C%20minimal%20powerful%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-power-peak-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20grand%20marble%20government%20hall%20with%20dramatic%20light%20shafts%2C%20deep%20navy%20and%20gold%20palette%2C%20powerful%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-power-peak-hero&orientation=landscape",
    year: 2024,
    region: "美国",
    genres: ["政治", "剧情", "惊悚"],
    rating: 8.7,
    duration: "58分钟/集",
    episodes: 18,
    director: "Nora Sterling",
    actors: ["Grant Miles", "Ivy Chen", "Paul Rooney"],
    tagline: "权力越高，风越冷。",
    synopsis: "一位理想主义的幕僚踏入权力中心，试图推动改革，却在博弈中逐渐看清规则的重量，也重新定义了自己的底线。",
    tags: ["权谋", "政治", "美剧"],
  },
  {
    id: "t-spring-confession",
    title: "春日告白",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20korean%20romance%20youth%20tv%20poster%20with%20cherry%20blossoms%20and%20soft%20pastel%20sky%2C%20light%20pink%20and%20sky%20blue%20palette%2C%20minimal%20romantic%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-spring-confession-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20spring%20campus%20with%20cherry%20blossoms%20and%20soft%20pastel%20sky%2C%20light%20pink%20and%20sky%20blue%20palette%2C%20romantic%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-spring-confession-hero&orientation=landscape",
    year: 2023,
    region: "韩国",
    genres: ["爱情", "青春", "校园"],
    rating: 8.3,
    duration: "35分钟/集",
    episodes: 16,
    director: "Choi Min-ji",
    actors: ["Seo Yeon", "Kang Do", "Yoon Ah"],
    tagline: "这个春天，我想告诉你。",
    synopsis: "转学生在樱花盛开的季节遇见了一个总是独自弹琴的少年。两个怀揣心事的年轻人，在春天里慢慢靠近。",
    tags: ["甜剧", "校园", "治愈"],
  },
  {
    id: "t-family-glory",
    title: "家族荣光",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20family%20saga%20period%20tv%20poster%20with%20a%20grand%20old%20courtyard%20house%20at%20dusk%2C%20warm%20sepia%20and%20deep%20green%20palette%2C%20minimal%20nostalgic%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-family-glory-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20old%20chinese%20courtyard%20house%20at%20dusk%20with%20warm%20lanterns%2C%20sepia%20and%20deep%20green%20palette%2C%20nostalgic%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-family-glory-hero&orientation=landscape",
    year: 2022,
    region: "中国大陆",
    genres: ["年代", "家族", "剧情"],
    rating: 8.5,
    duration: "46分钟/集",
    episodes: 48,
    director: "程守志",
    actors: ["赵德海", "钱秀兰", "孙博文"],
    tagline: "一个家族的百年沉浮。",
    synopsis: "从民国到当代，一个家族四代人的命运随着时代起伏。他们在变故中坚守，在离散后重逢，书写属于普通人的史诗。",
    tags: ["年代", "家族", "大剧"],
  },
  {
    id: "t-cold-case-chase",
    title: "悬案追踪",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20german%20crime%20drama%20tv%20poster%20with%20a%20rainy%20night%20bridge%20and%20distant%20city%20lights%2C%20cold%20slate%20blue%20and%20amber%20palette%2C%20minimal%20suspenseful%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-cold-case-chase-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20rainy%20night%20city%20bridge%20with%20distant%20lights%2C%20cold%20slate%20blue%20and%20amber%20palette%2C%20suspenseful%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-cold-case-chase-hero&orientation=landscape",
    year: 2024,
    region: "德国",
    genres: ["犯罪", "悬疑", "剧情"],
    rating: 8.8,
    duration: "52分钟/集",
    episodes: 22,
    director: "Klaus Richter",
    actors: ["Anna Weber", "Jonas Klein", "Petra Lang"],
    tagline: "时间会过去，真相不会。",
    synopsis: "一名女警坚持追查一桩二十年前的悬案。随着新的证据浮出水面，她要面对的不仅是凶手，还有当年被掩盖的一切。",
    tags: ["犯罪", "冷案", "德剧"],
  },
  {
    id: "t-fantasy-academy",
    title: "奇幻学园",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20fantasy%20youth%20tv%20poster%20with%20a%20magical%20floating%20academy%20castle%20among%20starlight%2C%20violet%20blue%20and%20gold%20palette%2C%20minimal%20magical%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=tv-fantasy-academy-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20magical%20academy%20castle%20floating%20among%20stars%20and%20aurora%2C%20violet%20blue%20and%20gold%20palette%2C%20magical%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=tv-fantasy-academy-hero&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["奇幻", "青春", "冒险"],
    rating: 8.1,
    duration: "40分钟/集",
    episodes: 30,
    director: "尹川",
    actors: ["苏晓", "凌越", "夏栀"],
    tagline: "在这里，每个人都能发光。",
    synopsis: "平凡少女意外考入一所悬浮于云端的魔法学园。她与伙伴们一起学习、成长，也逐渐揭开学园背后隐藏的秘密。",
    tags: ["青春", "奇幻", "成长"],
  },
];